// Static nav config for the Content Config Portal. All domain data (countries,
// verticals, personas, attributes, CVPs, products) — and their display labels —
// come from the ucd Content Portal API; nothing is mocked here.

export const NAV_ITEMS = [
  {
    id: 'product-offerings',
    labelKey: 'ucd_content_config.navigation.product_offerings',
    icon: 'sparkle',
    group: 'Generate',
  },
  {
    id: 'cvps',
    labelKey: 'ucd_content_config.navigation.cvps',
    icon: 'tag',
    group: 'Generate',
  },
  {
    id: 'persona',
    labelKey: 'ucd_content_config.navigation.persona_variables',
    icon: 'user',
    group: 'Generate',
  },
  {
    id: 'audiences',
    labelKey: 'ucd_content_config.navigation.audiences',
    icon: 'user',
    group: 'Audience',
  },
  {
    id: 'attrs',
    labelKey: 'ucd_content_config.navigation.user_attributes',
    icon: 'filter',
    group: 'Audience',
  },
  {
    id: 'countries',
    labelKey: 'ucd_content_config.navigation.countries',
    icon: 'globe',
    group: 'Audience',
  },
  {
    id: 'verticals',
    labelKey: 'ucd_content_config.navigation.verticals',
    icon: 'tag',
    group: 'Audience',
  },
];
